import React from 'react';

import { IconReactionPositiveSmall } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Container } from '../../../../symphony';

import { ActionType, RequestType } from '../../global-interface';
import { SlDiscussContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';

import s from './Voting.scss';

interface IVotingProps {
	voteCount: number;
	userVoteCount: number;
	postId: number;
}

export function Voting({ voteCount, userVoteCount, postId }: IVotingProps) {
	useStyles(s);
	const { actions$ } = Container.take(SlDiscussContext, SlActions);

	const positiveReactionClickHandler = () => {
		actions$.next({
			type: ActionType.OnPositiveReactionClick,
			requestType: RequestType.Parallel,
			data: {
				postId: postId.toString(),
			},
		});
	};

	const getVoteCount = () => {
		const voteCountABS = Math.abs(voteCount);

		if (voteCount > 0) {
			return `+ ${voteCountABS}`;
		}

		if (voteCount < 0) {
			return `- ${voteCountABS}`;
		}

		return 0;
	};

	return (
		<div className="discuss-voting">
			<IconReactionPositiveSmall
				className={`${
					userVoteCount > 0
						? 'discuss-voting__svg__active'
						: 'discuss-voting__svg'
				}`}
				onClick={positiveReactionClickHandler}
			/>
			<div className="discuss-voting__count">{getVoteCount()}</div>
		</div>
	);
}
